import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import { MyDrawer } from "./Component/Drawer/Drawer";
import ServiceNow from "./Page/ServiceNow/ServiceNow";
import Qualys from "./Page/Qualys/Qualys";
import Dashboard from "./Page/Dashboard/Dashboard";
import SumoLogic from "./Page/SumoLogic/SumoLogic";
import FMlogo from './images/FMLogo.png'

import './App.css';

function App() {
  const [open, setOpen] = React.useState(false);
  const [activeRoute, setActiveRoute] = React.useState('one');


  const handleOpen = () => {
    setOpen(!open);
  };

  const handleRoute = key => {
    setActiveRoute(key)
  }

  return (
    <div className="App">
     <Grid className="App-header">
       <Grid className="header-icon">
         <img src={FMlogo} alt="fm-logo"/>
       </Grid>
       <Grid className="header-title">
         <span className="header-title-label">Security Operations Unified Dashboard</span>
       </Grid>
     </Grid>
      <Grid className="App-main-box">
        <Grid className="App-main-drawer">
          <span onClick={handleOpen} className='drawer-handler'>{open ? '>' : '<'}</span>
          <MyDrawer
            open={open}
            handleRoute={handleRoute}
          />
        </Grid>
        <div className="App-divider"/>
        <Grid className="App-main-content">
          <Switch>
            <Route exact path="/" component={Dashboard} />
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/service-now" component={ServiceNow} />
            <Route path="/qualys" component={Qualys} />
            <Route path="/sumo-logic" component={SumoLogic}/>
            {/*<Route component={NotFound} />*/}
          </Switch>
        </Grid>
      </Grid>
    </div>
  );
}

export default App;
